import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { LocalStorageService } from "src/core/services/local-storage.service";
import { PrescriptionService } from "src/core/services/prescription.service";
import { Order } from "src/interfaces/order";

@Injectable({
    providedIn: 'root'
})
export class OrderResolver implements Resolve<any> {

    constructor(
        private _prescriptionService: PrescriptionService
    ) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<
        {
            order: Order | null;
            extras: any;
        }> {

        let order: Order | null = null;

        order = await this
            ._prescriptionService
            .getOrder(
                parseInt(route.params['id'])
            );

        // // get order  individual company

        // if (order && order.client)
        //     if (order.client.company_id)
        //         order.client.company = await this._companyService
        //             .getCompany(order.client.company_id);

        // if (order && order.patient)
        //     if (order.patient.company_id)
        //         order.patient.company = await this._companyService
        //             .getCompany(order.patient.company_id);

        // if (order && order.doctor)
        //     if (order.doctor.company_id)
        //         order.doctor.company = await this._companyService
        //             .getCompany(order.doctor.company_id);


        const extras = await this._prescriptionService
            .getFormData([
                'delivery_type',
                'individual_type',
                'order_item_status',
                'batch_status',
                'order_status',
                'company_type'
            ])
            .toPromise();

        return {
            order,
            extras
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrdersResolver implements Resolve<any> {
    limit: number = 10;
    page: number = 1;
    constructor(
        private prescriptionService: PrescriptionService,
        private localStorageService: LocalStorageService
    ) {
        const limit = this.localStorageService.get('ORDERS', 'LIMIT');
        if (limit) {
            this.limit = parseInt(limit);
        }
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<{
        orders: Order[],
        pageNumber: number,
        extras: any
    }> {
        const page = this.localStorageService.get('ORDERS', 'PAGE');
        if (page) {
            this.page = parseInt(page);
        } else {
            this.page = 1;
        }
        const orders = await this
            .prescriptionService
            .getOrders(this.page, this.limit);

        const data = await this.prescriptionService.getFormData(['order_status']).toPromise();
        const extras: any = {
            ...data
        }
        return {
            pageNumber: this.page,
            orders: orders,
            extras
        }
    }
}
